export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '971c1612-6102-4135-8652-6b792b0e9d9a';
export const MODAL_CLOSE_SEC = 2.5;
